import { z } from "zod";

export const OtaChannelResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.any(),
});
